//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/NXObject.js";
let d=[[],[[["comps"],"AddComponent",{},1,0],[["comps"],"RemoveComponent",{},1,0],[["opers"],"AddOperation",{},1,0],[["opers"],"RemoveOperation",{},1,0],[["adapters"],"AddSignalAdapters",{},1,0],[["adapters"],"RemoveSignalAdapters",{},1,0],[["pDestination"],"RestructureObject",{},1,0],[["objects"],"AddPhysicsObjects",{},1,0],[["objects"],"RemovePhysicsObjects",{},1,0],[["num","objects"],"GetPhysicsObjects",{},0,0],[["pDestination","before_or_after"],"ReorderObject",{},2,0],[["name"],"RenameInstance",{},1,0],[["pComplying"],"CreateTraceLink",{},1,0],[["pComplying"],"RemoveTraceLink",{},1,0],[[],"GetSingleDesignation",{R_:{designation:''}},0,0],[["designation"],"SetSingleDesignation",{},1,0],[[],"ApplyNamingRule",{},0,0],[["type","itemMFKID","revisionID"],"AssociateItem",{},3,0],[["type","itemMFKID","revisionID"],"GetAssociateItem",{},1,0],[["itemMFKID","revisionID"],"DissociateItem",{},2,0]],[]];
SPLM.Mechatronics.SystemObject = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.SystemObject";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.SystemObject.ReorderType = Object.freeze({
    "Before" : "Before", "After" : "After"});

SPLM.Mechatronics.SystemObject.RelationType = Object.freeze({
    "Ecad" : "Ecad"});

export default SPLM;